import React from 'react'
import { TeamCell } from './styles'
import { createUrl } from '../../../../Routing/urls'
import type { EventGQL } from '../../../../Api'
import { Lk } from '../../../../Components/Links/Lk'
type TeamsColParams = {
  week: string
  description: string
  awayTeam: string
  homeTeam: string
  event: EventGQL
}

export const TeamsCol: React.FC<React.PropsWithChildren<TeamsColParams>> = ({
  awayTeam,
  homeTeam,
  description,
  event
}) => {
  if (event.seasonSegment === 'allstar' || (event.seasonSegment === 'post' && !awayTeam && !homeTeam)) {
    return <div>{description}</div>
  }

  return (
    <TeamCell>
      <div className="results">
        {!awayTeam ? `TBD` : <Lk link={createUrl('teams', { id: awayTeam })} alt={`${awayTeam} team`}>{awayTeam}</Lk>} vs{' '}
        {!homeTeam ? `TBD` : <Lk link={createUrl('teams', { id: homeTeam })} alt={`${homeTeam} team`}>{homeTeam}</Lk>}
      </div>
    </TeamCell>
  )
}
